<template>
  <w-datepicker :title="title" :model="$schema.date" @input="updateValue" />
</template>

<script>
import moment from 'moment';

import { formMixin } from '@/mixins/form';

const schema = {
  properties: {
    date: { type: 'string', format: 'date' }
  }
};

// @vuese
// Datepicker bez schemy
// @group Form
export default {
  mixins: [formMixin],
  schema,
  props: {
    // Wartość
    value: { type: [Date, String] },
    // Wyświetlany tytuł
    title: { type: String, default: '' }
  },
  data() {
    return { model: {} };
  },
  watch: {
    value(newValue) {
      this.setSchemaData(newValue);
    }
  },
  mounted() {
    if (this.value && typeof this.value === 'string') {
      this.$emit('input', new Date(this.value));
    } else {
      this.setSchemaData(this.value);
    }
  },
  methods: {
    // @vuese
    // Ustawia wartość w schemie i tym samym na widoku
    setSchemaData(value) {
      if (value === this.$schema.date.$model) {
        return;
      }

      if (!value) {
        this.$schema.date.$setData(null);
      } else if (typeof value === 'string' || value instanceof Date) {
        this.$schema.date.$setData(moment(value).format('YYYY-MM-DD'));
      }
    },

    // @vuese
    // Ustawia wartość modelu przez emit eventu `input`
    updateValue(newValue) {
      this.$emit('input', newValue && moment(newValue, 'DD.MM.YYYY').toDate());
    }
  }
};
</script>
